export default class ModalForm {
	constructor(options) {
		this.checkParams(options);

		this.wasSubmit = false;

		this.ajax = options.ajax || null;
		this.content = options.content || '';
		this.fields = options.fields || null;
		this.title = options.title || 'Форма';
		this.onSubmit = options.onSubmit || null;
		this.onClose = options.onClose || null;
		this.onSuccess = options.onSuccess || null;
		this.onError = options.onError || null;

		this.handlerSubmit = this.handlerSubmit.bind(this);
		this.handlerClose = this.handlerClose.bind(this);

		this.init();

		return this;
	}

	init() {
		var modalTemplate = this.getModalTemplate();
		this.modal = $(modalTemplate);
		this.btnSubmit = this.modal.find('[data-role="btn-submit"]');
		this.message = this.modal.find('[data-role="message"]');

		this.addInputsHandlers();
		this.select2Init();

		$('body').append(this.modal);
		this.modal.modal('show');

		this.modal.find('form').on('submit', this.handlerSubmit);
		this.modal.on('hidden.bs.modal', this.handlerClose);
	}

	checkParams(options) {
		if (
			(!options.ajax && !options.onSubmit) ||
			(!options.content && !options.fields)
		) {
			throw new Error('Не переданы необходимые параметры');
		}
	}

	getModalTemplate() {
		return `<div class="modal fade" tabindex="-1" role="dialog">
                    <div class="modal-dialog" role="document">
                        <form class="modal-content" method="post" enctype="multipart/form-data">
                            <div class="modal-header">
                                <h5 class="modal-title">${this.title}</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                ${this.getBodyTemplate()}
                            </div>
                            ${this.getFooterTemplate()}
                        </form>
                    </div>
                </div>`;
	}

	getFormTemplate() {
		if (!this.fields) {
			return this.content;
		}

		var jqueryFields = this.fields.reduce(function (acc, field) {
			var el,
				attr = field.attr;

			switch (field.type) {
				case 'text':
				case 'date':
				case 'number':
				case 'email':
				case 'search':
				case 'tel':
				case 'url':
					attr.type = field.type;
					el = $('<input/>').attr(attr);
					break;
				case 'textarea':
					el = $('<textarea></textarea>').attr(attr);
					break;
				case 'select':
				case 'select2':
					var options = [];
					if (field.options) {
						options = field.options.map(function (opt) {
							return $('<option></option>')
								.attr('value', opt.value)
								.text(opt.text);
						});
					}
					if (attr.placeholder) {
						var placeholder = $('<option></option>')
							.attr({
								disabled: true,
								value: '',
								selected: true,
							})
							.text(attr.placeholder);
						options.unshift(placeholder);
					}
					if (field.type === 'select') {
						el = $('<select></select>');
					} else {
						el = $('<select data-select2-init></select>');
					}
					el = el.attr(attr).append(options);
				default:
				// throw new Error('Тип поля ' + attr.type + ' не поддерживается');
			}

			if (!el) {
				return acc;
			}

			el.addClass(field.className || '');
			acc.push($('<div class="form-group"></div>').append(el));
			return acc;
		}, []);
		return form.append(jqueryFields);
	}

	getMessageTemplate() {
		return `<div class="alert alert-info" role="alert" data-role="message" style="display: none"></div>`;
	}

	setMessage(text, type) {
		if (!text) {
			this.message.hide();
			return;
		}

		var messageClass = 'alert mb-0 mt-3';

		switch (type) {
			case 'success':
				messageClass += ' alert-success';
				break;
			case 'error':
				messageClass += ' alert-danger';
				break;
			default:
				messageClass += ' alert-info';
				break;
		}

		this.message.attr('class', messageClass).text(text);
		this.message.show();
	}

	request() {
		this.toggleDisablingBtns(true);
		this.setMessage('');
		const formData = this.getFormData();

		const defaultAjax = {
			url: window.location.href,
			method: 'POST',
			contentType: false,
			processData: false,
		};
		const data = this.ajax && this.ajax.data ? { ...this.ajax.data } : {};

		const options = this.ajax
			? { ...defaultAjax, ...this.ajax, data: data }
			: defaultAjax;

		if (options.data) {
			for (var i in options.data) {
				formData.append(i, options.data[i]);
			}
		}

		for (var pair of formData.entries()) {
			console.log(pair[0] + ', ' + pair[1]);
		}

		options.data = formData;
		console.log(options);

		$.ajax(options).always(
			$.proxy(function (response) {
				this.toggleDisablingBtns(false);
				if (response.success) {
					if (this.onSuccess) {
						this.onSuccess(response.data, this.modal);
					} else {
						var text = response.data || 'Данные успешно отправлены';
						this.setMessage(text, 'success');
						setTimeout(() => this.modal.modal('hide'), 2000);
					}
				} else {
					if (this.onError) {
						this.onError(response.errors, this.modal);
					} else {
						this.setMessage(
							response.errors || 'При отравке данных произошла ошибка',
							'error'
						);
						// this.modal.modal('hide');
						// console.error(response.errors ? response.errors : response);
					}
				}
			}, this)
		);
	}

	addInputsHandlers() {
		this.inputFileHandlers();
		this.inputDateHandlers();
	}

	inputFileHandlers() {
		this.modal.find('input[type="file"]').each(function () {
			$(this).on('change', (e) => {
				var file = e.target.files[0];
				if (file) {
					$(this).siblings('label').text(file.name);
				}
			});
		});
	}

	inputDateHandlers() {
		if (!window.BX.calendar) {
			return;
		}
		this.modal.find('input[type="date"]').each(function () {
			$(this).attr('type', 'text');
			$(this).on('click', () => {
				BX.calendar({ node: this, field: this, bTime: false });
			});
		});
	}

	getBodyTemplate() {
		return `${this.getFormTemplate()}${this.getMessageTemplate()}`;
	}

	getFooterTemplate() {
		return `<div class="modal-footer">
                <button type="submit" class="btn btn-primary" data-role="btn-submit">Отправить</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Отмена</button>
            </div>`;
	}

	handlerSubmit(e) {
		e.preventDefault();
		this.wasSubmit = true;
		if (this.onSubmit) {
			this.onSubmit(this.getFormData(), this);
			return;
		}
		try {
			this.request();
		} catch (e) {
			this.setMessage(e || 'Произошла ошибка', 'error');
		}
	}

	handlerClose() {
		if (this.onClose) {
			this.onClose(this.wasSubmit);
		}
		this.remove();
	}

	getFormData() {
		var form = this.modal.find('form').get(0);
		return form ? new FormData(form) : new FormData();
	}

	toggleDisablingBtns(isDisabled) {
		this.modal.find('button').each(function () {
			var btn = $(this);
			btn.attr('disabled', isDisabled);

			if (btn.data('role') === 'btn-submit') {
				if (isDisabled) {
					btn.prepend(
						'<span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>'
					);
				} else {
					btn.find('.spinner-border').remove();
				}
			}
		});
	}

	remove() {
		this.modal.remove();
	}

	close() {
		this.modal.modal('hide');
	}

	select2Init() {
		if ($().select2) {
			this.modal.find('select[data-select2-init]').each(function () {
				const select = $(this);
				const opt = select.data('select2-init').split(',');

				$(this).select2({
					theme: 'bootstrap4',
					tags: opt.includes('tags'),
				});
			});
		}
	}

	root() {
		return this.modal;
	}
}
